export enum CheckoutTypeEnum {
  Exit,
  TransferAuthorization,
  Cancellation,
}
